import React from "react";
import {Field} from "formik";
import {TreeSelect} from 'primereact/treeselect';

export default function NsFieldTreeSelect({
                                              name,
                                              value = '',
                                              placeholder = '',
                                              formikRef,
                                              onChange = () => {
                                              },
                                              isDisabled = false,
                                              options = [],
                                              validate = () => {
                                              },
                                              isWidth100 = true,
                                              isFormFieldInvalid = true,
                                          }) {


    return (
        formikRef && typeof formikRef !== "undefined" ?
            <Field
                name={name}
                component={TreeSelect}
                value={value}
                className={(isWidth100 ? "w-100" : '')}
                formikRef={formikRef}
                options={options}
                disabled={isDisabled}
                onChange={(val) => {
                    if (formikRef) {
                        formikRef.current.setFieldValue(name, val.value)
                    }
                    onChange(val);
                }}
                showClear
                filter
                placeholder={placeholder}
                validate={validate}
                invalid={isFormFieldInvalid()}
            />
            :
            <TreeSelect
                name={name}
                value={value}
                className={(isWidth100 ? "w-100" : '')}
                formikRef={formikRef}
                options={options}
                disabled={isDisabled}
                onChange={onChange}
                showClear
                filter
                placeholder={placeholder}
                invalid={isFormFieldInvalid()}
            />
    );
}